import angular from 'angular';
import angularGettext from 'angular-gettext';
import localStorage from 'angular-local-storage';
import userResource from '../UsersModules/UserResource';

export default angular.module('cms.language.manager', [angularGettext, localStorage, userResource]).factory('languageManager',
    function(gettextCatalog, UserResource, CMSAuthService) {

        let service = {};

        /**
         * Set current app language
         * @param language
         */
        service.setLanguage = function (language) {
            gettextCatalog.setCurrentLanguage(language);
            let currentUser = CMSAuthService.getUser();

            UserResource.update({
                id: currentUser.id,
                language: language
            });

            currentUser.language = language;
            CMSAuthService.setUser(currentUser);
        };

        /**
         * Get current user language
         * @returns {string}
         */
        service.getLanguage = function () {
            return CMSAuthService.getUser() ? CMSAuthService.getUser().language : 'pl';
        };

        return service;

    }).name;


// WEBPACK FOOTER //
// ./src/cmsCore/Language/LanguageManager.js